import i from './tracking-status-behandle.container';

export default i;
